const Reason = {

    // FIELDS
    "reason": "Reason",
    "name": "Name",
    "reason_code": "Reason Code",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "Reason",
    "filter_title": "Reason Filter",

    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",

    // ERROR
    "error_name": "Enter Reason Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default Reason;

